<template>
      <div class="dropdown">
        <a class="dropdown__btn dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
          {{ name.replace('_', ' ') }}
        </a>
        <div class="dropdown__menu dropdown-menu" aria-labelledby="dropdownMenuLink">
            <div class="" v-for="checkbox in parametr" :key="checkbox.id">
              <div v-if="checkbox.name !== 'School Types'">
                <div class="row" v-if="checkbox.children">
                <div class="col-md-4 dropdown__col">
                  <div class="form-check form-check--first">
                      <input class="form-check-input " type="checkbox" :name="checkbox.name" :data-item-id="checkbox.id" :id="`select-all-${checkbox.id}`" @change="selectOnChange(name, $event, null)" :checked="checkbox.selected" :data-checked="checkbox.selected">
                      <label class="form-check-label" :for="`select-all-${checkbox.id}`">{{checkbox.name}}</label>
                  </div>
                    <div class="form-check" v-for="(children, index) in checkbox.children" v-bind:key="index">
                        <input class="form-check-input" type="checkbox" :name="children.name" :data-item-id="children.id" :id="children.name + children.id" @change="selectOnChange(name, $event, checkbox.name)" :checked="children.selected">
                        <label class="form-check-label form-check-label--light" :for="children.name + children.id">{{children.name}}</label>
                    </div>
                </div>
              </div>

              <div class="form-check form-check--first" v-else>
                <input class="form-check-input" type="checkbox" :id="checkbox.name" :data-item-id="checkbox.id" name="parametrCheckbox" @change="selectOnChange(name, $event, null)" :checked="checkbox.selected">
                <label class="form-check-label form-check-label--light" :for="checkbox.name">{{checkbox.name}}</label>
              </div>
            </div>
          </div>

        </div>
    </div>
</template>


<script>
  export default {
    name: "AppFilterDropdown",
    props: {
      parametr: Array,
      name: String,
      selectOnChange: Function,
    },
    data() {
      return {
      }
    },
    computed: {
    },
    methods: {
    },
  }
</script>

